import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type FontSizeOption = 'small' | 'medium' | 'large';

interface FontSizePreset {
  label: string;
  px: number;
}

@Injectable({
  providedIn: 'root'
})
export class FontSizeService {
  private readonly STORAGE_KEY = 'chatFontSize';
  private readonly DEFAULT: FontSizeOption = 'medium';

  readonly presets: Record<FontSizeOption, FontSizePreset> = {
    small:  { label: 'Small',  px: 13 },
    medium: { label: 'Medium', px: 15 },
    large:  { label: 'Large',  px: 19 },
  };

  readonly options: FontSizeOption[] = ['small', 'medium', 'large'];

  private selectedSubject: BehaviorSubject<FontSizeOption>;
  selected$;

  constructor() {
    const saved = localStorage.getItem(this.STORAGE_KEY) as FontSizeOption | null;
    const initial = saved && this.presets[saved] ? saved : this.DEFAULT;
    this.selectedSubject = new BehaviorSubject<FontSizeOption>(initial);
    this.selected$ = this.selectedSubject.asObservable();
  }

  get selected(): FontSizeOption {
    return this.selectedSubject.value;
  }

  get currentSize(): number {
    return this.presets[this.selected].px;
  }

  select(option: FontSizeOption): void {
    this.selectedSubject.next(option);
    localStorage.setItem(this.STORAGE_KEY, option);
  }
}
